import {Injectable} from '@angular/core';
import {BaseModelService} from '../base-model.service';
import {NotificationDto} from '../../../Models/Notification/notification.interface';

@Injectable({
  providedIn: 'root'
})
export class NotificationsModelService extends BaseModelService {

  tableName = 'yu_v3_notifications';

  public numNotifications: number = 0;

  /**
   * Número de notificaciones no vistas
   *
   */
  public getNotRead() {
    this.numNotifications = this.data?.filter((not: NotificationDto) => not.vista === 0)?.length ?? 0;
  }

}
